import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import { STATUS_GROUPS } from "@/commands/sessions/sessions-constants";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";
export async function listSessions(parsed: ParsedArgs): Promise<void> {
  args.expect(parsed, {
    flags: ["status", "repo", "search", "page", "limit"],
    booleans: ["all"],
    positional: 1,
  });

  const result = expectShape<ApiOutputs["sessions"]["list"]>(
    await api("/sessions", {
      query: {
        statusGroup: args.choice(parsed, "status", STATUS_GROUPS),
        repoFullName: parsed.flags.repo,
        search: parsed.flags.search,
        page: args.integer(parsed, "page", { min: 1 }),
        limit: args.integer(parsed, "limit", { min: 1, max: 100 }),
        scope: parsed.booleans.has("all") ? "all" : undefined,
      },
    }),
    "GET /sessions",
    { data: is.array, "pagination.page": is.number },
  );

  if (parsed.booleans.has("json")) {
    out.json(result);
    return;
  }

  if (result.data.length === 0) {
    out.line("No sessions.");
    return;
  }

  if (result.pagination.hasNextPage) {
    out.line(
      out.paint(
        `page ${result.pagination.page}/${result.pagination.totalPages} — --page ${result.pagination.page + 1} for more`,
        "dim",
      ),
    );
    out.line();
  }

  out.table(
    result.data.map((session) => [
      out.cell(session.id),
      out.status(session.status),
      out.cell(session.repoFullName ?? "—"),
      out.cell(session.title),
    ]),
  );
}
